<div class="p-10 rounded-xl" (keydown.enter)="submit()">
  <!-- Dialog Title -->
  <h5 class="text-lg font-semibold mb-4 text-gray-900">Edit Contact</h5>

  <!-- Dialog Content -->
  <div>
    <!-- Form -->
    <form [formGroup]="editContactForm" class="space-y-4">
      <div class="w-full mt-1">
        <!-- First name Field -->
        <div class="mb-4">
          <label class="block text-sm font-medium leading-6 text-gray-900">First
            name</label>
          <input type="text" id="name_first" formControlName="name_first" required
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-cg-orange sm:text-sm sm:leading-6">
        </div>

        <!-- Last name Field -->
        <div class="mb-4">
          <label class="block text-sm font-medium leading-6 text-gray-900">Last name</label>
          <input type="text" id="name_last" formControlName="name_last" required
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-cg-orange sm:text-sm sm:leading-6">
        </div>

        <!-- Phone Field -->
        <div class="mb-4">
          <label class="block text-sm font-medium leading-6 text-gray-900">Phone</label>
          <input type="text" id="phone" formControlName="phone" required
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-cg-orange sm:text-sm sm:leading-6">
        </div>

        <!-- Email Field -->
        <div class="mb-4">
          <label class="block text-sm font-medium leading-6 text-gray-900" for="email">Email</label>
          <input type="text" id="email" formControlName="email" required
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-cg-orange sm:text-sm sm:leading-6">
        </div>
      </div>
    </form>
  </div>

  <!-- Dialog Actions -->
  <div class="flex justify-end space-x-2 mt-4">
    <button type="button"
      class="border border-gray-300 text-gray-700 rounded-md px-4 py-2 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
      (click)="onNoClick()">Cancel</button>
    <button type="button"
      class="bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      (click)="submit()" [disabled]="editContactForm.invalid">Save</button>
  </div>

</div>
